import { useState, useEffect } from 'react';

import MultiSelectInput from '../../inputs/MultiSelectInput';
import { getOptionsForKey } from '../../../helpers/multiSelectOptions';

export default function MultiSelectOptions({
  id,
  name,
  attrs = {},
  setVariablesState,
  initialState,
}) {
  // ATAD-134: the map and both fallbacks now live in helpers/multiSelectOptions
  // so audienceBreadth.ts resolves the exact same list when checking whether
  // every option is selected.
  const options = getOptionsForKey(attrs.optionsKey);

  const [value, setValue] = useState(() => {
    return null;
  });

  // Handle initial state (for loading saved audiences)
  useEffect(() => {
    if (initialState && initialState.values) {
      setValue(initialState.values);
      if (typeof setVariablesState === 'function') {
        setVariablesState(
          { values: initialState.values },
          { loadingInitialState: true }
        );
      }
    }
  }, [initialState, setVariablesState]);

  function handleSelectAll() {
    setValue(options);
    if (typeof setVariablesState === 'function') {
      setVariablesState({ values: options });
    }
  }

  function handleChange(value) {
    if (!value) {
      if (typeof setVariablesState === 'function') {
        setValue(value);
        setVariablesState({ values: value });
        return;
      }
    }
    setValue(value);
  }

  function handleBlur() {
    if (typeof setVariablesState === 'function') {
      setVariablesState({ values: value });
    }
  }

  return (
    <div class="flex flex-col w-full border-l-2 border-gray-400 px-2 mb-2">
      <div
        className={`mb-1 ${
          options.length > 1 ? 'flex flex-row justify-between' : ''
        }`}
      >
        {name}
        {options.length > 1 && (
          <button
            type="button"
            className="text-sm text-blue hover:text-primary"
            onClick={handleSelectAll}
          >
            Select All
          </button>
        )}
      </div>
      <MultiSelectInput
        options={options}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  );
}
